export default {
    state: {
        breadcrumbs: [],
    },

    getters: {
        breadcrumbs: (state) => {
            return state.breadcrumbs
        }
    },

    mutations: {
        setBreadcrumbs(state, payload){
            state.breadcrumbs = payload
        }
    },

    actions: {
        setBreadcrumbs({commit}, payload){
            commit('setBreadcrumbs', payload)
        }
    },
}
